'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002417 from "./presto.-Agent-View$$anon$17.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dCert$002dChain$002dRequest$0024 from "./presto.-Agent-View$-Local-Shodo-Cert-Chain-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$16() {
  this.ax8 = null;
  this.ax0 = null;
  this.ax1 = false;
  this.ax9 = null;
  this.axa = false;
  this.axd = null;
  this.ax6 = null;
  this.ax7 = false;
  this.ax2 = null;
  this.ax3 = false;
  this.ax4 = null;
  this.ax5 = false;
  this.axb = false;
  this.axc = false;
  this.ax8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.axd = "LocalShodoCertChainRequest";
}
export { $c_Lpresto_AgentView$$anon$16 as $c_Lpresto_AgentView$$anon$16 };
$p = $c_Lpresto_AgentView$$anon$16.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$16;
/** @constructor */
function $h_Lpresto_AgentView$$anon$16() {
}
export { $h_Lpresto_AgentView$$anon$16 as $h_Lpresto_AgentView$$anon$16 };
$h_Lpresto_AgentView$$anon$16.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.ax8;
});
$p.M = (function() {
  if ((!this.ax1)) {
    this.ax0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.ax1 = true;
  }
  return this.ax0;
});
$p.O = (function() {
  if ((!this.axa)) {
    this.ax9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.axa = true;
  }
  return this.ax9;
});
$p.D = (function() {
  return this.axd;
});
$p.t = (function() {
  if ((!this.ax7)) {
    this.ax6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ax7 = true;
  }
  return this.ax6;
});
$p.N = (function() {
  if ((!this.ax3)) {
    this.ax2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fi(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ax3 = true;
  }
  return this.ax2;
});
$p.Q = (function() {
  if ((!this.ax5)) {
    this.ax4 = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002417.$c_Lpresto_AgentView$$anon$17();
    this.ax5 = true;
  }
  return this.ax4;
});
$p.v = (function() {
  if ((!this.axc)) {
    this.axb = false;
    this.axc = true;
  }
  return this.axb;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee110) => ((p) => \u03b4scrutinee110.cGS(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dCert$002dChain$002dRequest$0024.$m_Lpresto_AgentView$LocalShodoCertChainRequest$())));
});
var $d_Lpresto_AgentView$$anon$16 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$16, "presto.AgentView$$anon$16", ({
  DK: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$16 as $d_Lpresto_AgentView$$anon$16 };
//# sourceMappingURL=presto.-Agent-View$$anon$16.js.map
